module.exports = __webpack_public_path__ + "img/atlas_5000ml.499657c7.png";